// extracted by mini-css-extract-plugin
export default {"container":"SuccessScreen_container__Y1WmH","title":"SuccessScreen_title__eocjo","content":"SuccessScreen_content__isMGS","buttonContainer":"SuccessScreen_buttonContainer__0XMg2"};